import ClipboardJS from 'clipboard';

import hljs from 'highlight.js/lib/core';
import 'highlight.js/styles/stackoverflow-light.css';
import range from 'lodash/range';

hljs.registerLanguage('apache', require('highlight.js/lib/languages/apache'));
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('diff', require('highlight.js/lib/languages/diff'));
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('sql', require('highlight.js/lib/languages/sql'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));
hljs.registerLanguage('xml', require('highlight.js/lib/languages/xml'));

function highlight(el) {
    const code = el.querySelector('code');

    // Highlight the syntax
    hljs.highlightBlock(code);

    // Highlight the lines
    if (el.dataset.snippetHighlight) {
        let lines = [];
        let start;
        let stop;

        // Get the lines
        el.dataset.snippetHighlight.split(',').forEach((chunk) => {
            if (chunk.indexOf('-') !== -1) {
                [start, stop] = chunk.split('-').map(i => parseInt(i, 10));
                lines = lines.concat(range(start - 1, stop));
            } else {
                lines.push(chunk);
            }
        });

        let index = 0;

        code.innerHTML = code.innerHTML.replace(/([ \S]*\n|[ \S]*$)/gm, (match) => {
            let cssClass = 'hljs-line';

            if (lines.includes(index)) {
                cssClass += ' hljs-line-highlighted';
            }

            index++;

            return `<div class="${cssClass}">${match}</div>`;
        });
    }
}

function clipboard(el) {
    const button = el.querySelector('[data-snippet-copy]');

    const clipboard = new ClipboardJS(button, {
        target: () => el.querySelector('[data-snippet-code]'),
    });

    clipboard.on('success', (e) => {
        e.clearSelection();
        button.innerText = button.dataset.snippetCopy;
    });
}

export default function (els) {
    els.forEach((el) => {
        clipboard(el);
        highlight(el);
    });
}
